import { Component, OnInit } from '@angular/core';
import { SsoService } from '@services/sso.service';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  standalone: false
})
export class PasswordResetComponent implements OnInit {

  constructor(
    private ssoService: SsoService,
  ) { }

  ngOnInit(): void {
    this.ssoService.subscribeStatus$()
      .pipe(filter((status: any) => !!status))
      .pipe(take(1))
      .subscribe((status: any) => {
        this.ssoService.redirectToPasswordReset('password_reset');
      });
  }
}
